import { GHLLanguageKeys as o } from "./ghl-ui.es255.js";
import e from "./ghl-ui.es775.js";
const r = {
  name: o.norwegian,
  locale: e
};
export {
  r as date_no
};
